module.exports = __webpack_public_path__ + "static/media/33-11.dbd42ff2.mp3";